export const ASSIGNMENT_ID_PARAM = 'assignmentId'
export const SUBMISSION_ID_PARAM = 'submissionId'
export const LAYER_ID_PARAM = 'layerId'
export const PATTERN_ID_PARAM = 'patternId'
export const LINES_PARAM = 'lines'
export const ASSIGNMENT_TOKEN_PARAM = 'atok'
export const IS_ADDING_TO_EXISTING_PATTERN_PARAM = 'isAddingToExistingPattern'
export const TOKEN_PARAM = 'token'
export const T_PARAM = 't'
export const FILE_TOKEN_PARAM = 'file_token'
export const FILE_TOKENS_PARAM = 'file-tokens'
export const CATALOG_ITEM_ID_PARAM = 'catalog-item-id'
export const RESET_PASSWORD_CODE_PARAM = 'code'
export const USER_ID_PARAM = 'user_id'
export const PROBLEM_SET_ID_PARAM = 'problem_set_id'
export const VERSION_ID_PARAM = 'version_id'
export const SEARCH_PARAM = 'search'
export const ASSIGNMENT_SEARCH_PARAM = 'assignment-search'
export const SUBMISSION_SEARCH_PARAM = 'submission-search'
export const USER_SEARCH_PARAM = 'user-search'
export const SORT_PARAM = 'sort'
export const FLAGGED_PARAM = 'escalated'
export const FLAGGED_FOR_MYSELF_PARAM = 'escalated-for-myself'
export const GROUP_BY_PARAM = 'group-by'
export const TYPE_PARAM = 'assignment-type'
export const LANGUAGE_PARAM = 'language'
export const COURSE_PARAM = 'course'
export const OWNER_PARAM = 'owner'
export const PERMISSION_LEVEL_PARAM = 'permission-level'
export const ORGANIZATION_PARAM = 'organization'
export const PAGE_PARAM = 'page'
export const PAGE_SIZE_PARAM = 'page-size'
export const IS_NON_LBE_PATTERN_PARAM = 'is-non-lbe-pattern'
export const SIMILARITY_FUNCTION_PARAM = 'similarity-function'
export const METHOD_PARAM = 'method'
export const LINES_TO_REMOVE_PARAM = 'lines-to-remove'
export const IMMEDIATELY_SAVE_PATTERN_PARAM = 'immediately-save-pattern'
export const MISMATCH_PARAM = 'mismatch'
export const REVIEW_STATUS_PARAM = 'review-status'
export const CONFIDENCE_LEVELS_PARAM = 'confidence-levels'
export const ASSIGNEE_IDS_PARAM = 'assignee'
export const OPEN_SUBMISSION_ID_PARAM = 'open-submission-id'
export const FOCUS_QUESTION_ID_PARAM = 'focus-question-id'
export const STUDENT_FEEDBACK_PARAM = 'studentFeedbackFilters'
export const STUDENT_FEEDBACK_EXACT_MATCH_PARAM = 'studentFeedbackExactMatch'
export const SEARCH_TYPE_PARAM = 'search-type'
export const TEST_SET_ONLY_PARAM = 'test-set-only'
